const features = [
  {
    icon: 'ri-shield-check-line',
    title: 'Enhanced Security',
    description:
      'Our applications are built with security at their core. Every data transmission is encrypted, every user action is protected, and your personal information never leaves your device without your consent.',
    wide: false,
    tall: false,
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Performance Optimization',
    description:
      'We obsess over performance. Our apps are lightweight, battery-efficient, and designed to run smoothly even on older iOS devices without draining resources.',
    wide: false,
    tall: true,
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Intuitive Interface',
    description:
      'Following Apple\'s Human Interface Guidelines, our apps feel native and natural. Clean layouts, familiar gestures, and thoughtful interactions make every task effortless.',
    wide: true,
    tall: false,
  },
  {
    icon: 'ri-refresh-line',
    title: 'Regular Updates',
    description:
      'We continuously improve our products with regular updates, new features, and security patches to keep up with the latest iOS versions and emerging threats.',
    wide: false,
    tall: false,
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Privacy Protection',
    description:
      'We operate on a strict zero-log policy. We don\'t track, store, or sell your data. Your privacy is not a feature — it\'s a fundamental right we protect.',
    wide: false,
    tall: false,
  },
];

export default function Features() {
  return (
    <section id="features" className="bg-[#111318] py-28 md:py-36">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <span className="text-slate-400 text-xs font-semibold tracking-[0.25em] uppercase">Features</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-4">
            Why Choose Our Solutions
          </h2>
          <p className="text-slate-400 text-lg max-w-xl mx-auto">
            Every feature is thoughtfully designed to deliver real value to iOS users worldwide.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Row 1: card 0 (1 col), card 1 (1 col tall - spans 2 rows), card 2 (wide - 2 cols) */}
          {/* We'll lay them out manually for the staggered effect */}

          {/* Top-left: Enhanced Security */}
          <div className="bg-[#1c1f27] rounded-2xl p-8 border border-slate-800 flex flex-col gap-5">
            <div className="w-12 h-12 flex items-center justify-center bg-slate-700/50 rounded-xl">
              <i className={`${features[0].icon} text-slate-300 text-2xl`} />
            </div>
            <div>
              <h3 className="text-white font-semibold text-xl mb-3">{features[0].title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{features[0].description}</p>
            </div>
          </div>

          {/* Top-center: Performance (tall, spans 2 rows) */}
          <div className="bg-[#1c1f27] rounded-2xl p-8 border border-slate-800 flex flex-col gap-5 md:row-span-2">
            <div className="w-12 h-12 flex items-center justify-center bg-slate-700/50 rounded-xl">
              <i className={`${features[1].icon} text-slate-300 text-2xl`} />
            </div>
            <div>
              <h3 className="text-white font-semibold text-xl mb-3">{features[1].title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{features[1].description}</p>
            </div>
            <div className="mt-auto rounded-xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/917a2d984c0dafd152ff6a8bdaf4d657.jpg"
                alt="Performance visualization"
                className="w-full h-48 object-cover object-top rounded-xl"
              />
            </div>
          </div>

          {/* Top-right: Regular Updates */}
          <div className="bg-[#1c1f27] rounded-2xl p-8 border border-slate-800 flex flex-col gap-5">
            <div className="w-12 h-12 flex items-center justify-center bg-slate-700/50 rounded-xl">
              <i className={`${features[3].icon} text-slate-300 text-2xl`} />
            </div>
            <div>
              <h3 className="text-white font-semibold text-xl mb-3">{features[3].title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{features[3].description}</p>
            </div>
          </div>

          {/* Bottom-left wide (2 cols): Intuitive Interface */}
          <div className="bg-[#1c1f27] rounded-2xl p-8 border border-slate-800 flex flex-col md:flex-row gap-6 md:col-span-1">
            <div className="flex flex-col gap-5">
              <div className="w-12 h-12 flex items-center justify-center bg-slate-700/50 rounded-xl">
                <i className={`${features[2].icon} text-slate-300 text-2xl`} />
              </div>
              <div>
                <h3 className="text-white font-semibold text-xl mb-3">{features[2].title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{features[2].description}</p>
              </div>
            </div>
          </div>

          {/* Bottom-right: Privacy Protection */}
          <div className="bg-[#1c1f27] rounded-2xl p-8 border border-slate-800 flex flex-col gap-5">
            <div className="w-12 h-12 flex items-center justify-center bg-slate-700/50 rounded-xl">
              <i className={`${features[4].icon} text-slate-300 text-2xl`} />
            </div>
            <div>
              <h3 className="text-white font-semibold text-xl mb-3">{features[4].title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{features[4].description}</p>
            </div>
          </div>
        </div>


      </div>
    </section>
  );
}
